/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * useNow.ts — us\1 \2ow (services/operator-web-app).
 */

import { useState, useEffect } from 'react';

/**
 * Returns current timestamp, updating at the given interval.
 * Useful for TTL/degraded checks that need to re-render periodically.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
